import styled from 'styled-components';

export const StandardPerformanceSelectorContainer = styled.div`
  margin-top: ${({ theme }) => theme.spacing.sm};
  margin-bottom: ${({ theme }) => theme.spacing.xm};
  row-gap: ${({ theme }) => theme.spacing.m};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  /* 1 button */
  & > div:only-child {
    width: 100%;
  }

  /* 2 button */
  & > div:nth-child(1):nth-last-child(2),
  & > div:nth-child(2):nth-last-child(1) {
    width: 48%; /* Aproximadamente 50% com gap */
  }

  /* 3 button */
  & > div:nth-child(1):nth-last-child(3) {
    width: 100%;
  }

  & > div:nth-child(2):nth-last-child(2),
  & > div:nth-child(3):nth-last-child(1) {
    width: 48%; /* 50% com gap */
  }
`;
